"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageStyles = void 0;
exports.messageStyles = {
    display: 'block',
    background: 'white',
    position: 'relative',
    margin: '1.75rem auto',
    top: '5em',
    borderRadius: '5px',
    zIndex: '1048',
    borderBottom: '1px solid #DCDCDC'
};
